import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl-next';

import PersonIcon from '@atlaskit/icon/core/person';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

export const SegmentationMessage: React.FC = () => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.050" alignInline="start" alignBlock="center">
			<PersonIcon
				label={formatMessage(messages.segmentationMessageRestricted)}
				color={token('color.icon.subtle')}
			/>

			<Text size="small" color="color.text.subtlest">
				<FormattedMessage {...messages.segmentationMessageRestricted} />
			</Text>
		</Inline>
	);
};
